import { usePsfSharePageData, usePsfSharePageState } from '#src/app/pages/psf/share/pageContext';
import { SHARE_GOAL_COUNTER_STEPS } from '#src/app/pages/psf/share/shared/consts';
import { isShareGoalCounterEligible } from '#src/app/pages/psf/share/shared/utils';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

import { useShouldShowSharingGoalFlow } from '../useShouldShowSharingGoalFlow';

type Result = Readonly<{
	isActive: boolean;
	count: number;
}>;

/**
 * Share Goal Counter (CHANGE-97807) `variant_1`. A share made from the slide-up before landing here counts
 * as the first one (`slide_up_source` is only set by that share's success redirect, never on Continue).
 */
export function useShareGoalCounter(): Result {
	const {
		data: {
			initial,
			experiments: { psfShareGoalCounterExperiment: experiment },
		},
	} = usePsfSharePageData();
	const shouldShowSharingGoalFlow = useShouldShowSharingGoalFlow();
	const [{ shareCount }] = usePsfSharePageState();
	const slideUpSource = useQueryParamValue('slide_up_source');

	const isActive =
		shouldShowSharingGoalFlow &&
		isShareGoalCounterEligible({ experiment, initial }) &&
		experiment.variation === 'variant_1';

	return {
		isActive,
		count: Math.min(SHARE_GOAL_COUNTER_STEPS, (slideUpSource ? 1 : 0) + shareCount),
	};
}
